import { createFileRoute, notFound } from '@tanstack/react-router'

import { VitrineComponentesPage } from '@/features/dev_componentes/vitrine-componentes-page'

// Vitrine de componentes: existe só em desenvolvimento, para comparar com o protótipo.
export const Route = createFileRoute('/dev/componentes')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- é assim que o TanStack Router pede
    if (!import.meta.env.DEV) throw notFound()
  },
  component: VitrineComponentesPage,
})
